import React, { useState, useEffect } from 'react';
import '../Carousel/carousel.css';

const Carousel = (props) => {
  const { imgs } = props;
  const [isActive, setIsActive] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [length, setLength] = useState(imgs.length);
  useEffect(() => {
    setLength(imgs.length);
  }, [imgs]);

  const next = () => {
    if (currentIndex < length - 1) {
      setCurrentIndex((prevState) => prevState + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  const handleClick = ({ target }) => {
    setIsActive((current) => !current);
    if (!document.fullscreenElement) {
      target.requestFullscreen().catch((error) => console.log(error));
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <div className="carousel">
      <div className="carousel__wrapper">
        <button className="carousel__wrapper-left-arrow" onClick={prev}>
          &lt;
        </button>
        <div className="carousel__content-wrapper">
          <div
            className="carousel__content"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {props.imgs.map((img) => (
              <img
                src={img.src}
                alt={img.alt}
                style={{
                  objectFit: isActive ? 'contain' : '',
                  backgroundColor: isActive ? 'rgba(255,250,250)' : '',
                }}
                onClick={handleClick}
              />
            ))}
          </div>

          <div className="carousel__content-dots">
            {imgs.map((img) => (
              <span
                key={img.id}
                className={
                  imgs[currentIndex].id === img.id ? 'dot active' : 'dot'
                }
                onClick={() => setCurrentIndex(imgs.indexOf(img))}
              ></span>
            ))}
          </div>
        </div>
        <button className="carousel__wrapper-right-arrow" onClick={next}>
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Carousel;
